import { createContext } from '@lit/context';
import type { VtoService } from '../service/vto-service.js';

export const vtoContext = createContext<VtoService>('vtoContext');
